// extracted by mini-css-extract-plugin
export default {"btn-link":"LinkButton_btn-link__eno0-"};